import { useTranslation } from "react-i18next";
import { getTeamRoleI18nKey } from "../teamRole";
import type { TeamRole } from "../types";

export interface TeamRoleLabelProps {
  role: TeamRole | string | undefined;
}

export function TeamRoleLabel({ role }: TeamRoleLabelProps) {
  const { t } = useTranslation();
  return <>{t(getTeamRoleI18nKey(role))}</>;
}
